import {
  BASE_MAP_LAYERS,
  EQUIPAMENTS_LAYER,
  DATA_MODE_INITIAL_STATE,
  MAP_LAYERS_WMS,
  PLANTES_BAIXES_LAYER,
  SOTERRANIS_LAYER,
  ALL_FLOODS_LAYER,
} from "src/app/constants";
import {
  AllFloodsLayerConfig,
  BaseMapLayerConfig,
  DataMode,
  DragRiskLayerConfig,
  EquipamentsLayerConfig,
  FloodLayerConfig,
  MapLayerWMSConfig,
  PlantesBaixesLayerConfig,
  SoterranisLayerConfig,
  WMSLayerLastUpdate,
} from "src/app/interfaces";
import {
  BlackSpotDataDto,
  BlackSpotDto,
  CatchmentDto,
  IslandDto,
  StationDataDto,
  StationDto,
  StationSimulationDataDto,
  WatershedDto,
  ZoneDataDto,
} from "src/app/services/api";

export interface Islands {
  [id: string]: IslandDto;
}

export interface Watersheds {
  [id: string]: WatershedDto;
}

export interface Catchments {
  [id: string]: CatchmentDto;
}

export interface IslandCatchments {
  [id: string]: { [id: string]: CatchmentDto };
}

export interface CatchmentsData {
  [id: string]: ZoneDataDto;
}

export interface CatchmentStations {
  [id: string]: StationDto[];
}

export interface StationsData {
  [id: string]: StationDataDto;
}

export interface StationsSimulationData {
  [id: string]: StationSimulationDataDto;
}

export interface Blackspots {
  [id: string]: BlackSpotDto[];
}

export interface BlackspotsData {
  [id: string]: BlackSpotDataDto;
}

export interface WatershedState {
  islands: Islands;
  watersheds: Watersheds;
  islandId: string;
  hoveredIslandId: string;
  watershedId: number;
  hoveredWatershedId: number;
  allCatchments: Catchments;
  catchmentId: number;
  hoveredCatchmentId: number;
  catchmentsData: CatchmentsData;
  catchmentStations: CatchmentStations;
  stationCode: string;
  hoveredStationCode: string;
  stationsData: StationsData;
  stationsSimulationData: StationsSimulationData;
  catchmentWaterLevelStationCode: string;
  catchmentDischargeStationCode: string;
  catchmentPrecipitationStationCode: string;
  catchmentBlackspots: Blackspots;
  blackspotsData: BlackspotsData;
  blackspotId: string;
  mapLayerConfig: BaseMapLayerConfig;
  mapLayerWMS: MapLayerWMSConfig;
  equipamentsLayer: EquipamentsLayerConfig;
  plantesBaixesLayer: PlantesBaixesLayerConfig;
  soterranisLayer: SoterranisLayerConfig;
  floodsLayer: AllFloodsLayerConfig;
  dataMode: DataMode;
  riversLayer: MapLayerWMSConfig;
  lastUpdatesLayerWMS: WMSLayerLastUpdate[];
  loading: boolean;
  radarAvailable: boolean;
  heatIndexThresholds: Array<number>;
  windChillThresholds: Array<number>;
  thresholdsLoaded: boolean;
}

export const initialState: WatershedState = {
  islands: {},
  watersheds: {},
  islandId: null,
  hoveredIslandId: null,
  watershedId: null,
  hoveredWatershedId: null,
  allCatchments: {},
  catchmentId: null,
  hoveredCatchmentId: null,
  catchmentsData: {},
  catchmentStations: {},
  stationCode: null,
  hoveredStationCode: null,
  stationsData: {},
  stationsSimulationData: {},
  catchmentWaterLevelStationCode: null,
  catchmentPrecipitationStationCode: null,
  catchmentDischargeStationCode: null,
  catchmentBlackspots: {},
  blackspotsData: {},
  blackspotId: null,
  mapLayerConfig: BASE_MAP_LAYERS.BiN,
  mapLayerWMS: MAP_LAYERS_WMS.Precipitation1h,
  equipamentsLayer: EQUIPAMENTS_LAYER.None,
  plantesBaixesLayer: PLANTES_BAIXES_LAYER.None,
  soterranisLayer: SOTERRANIS_LAYER.None,
  floodsLayer: ALL_FLOODS_LAYER.None,
  dataMode: DATA_MODE_INITIAL_STATE,
  riversLayer: MAP_LAYERS_WMS.RiversZoomOut,
  lastUpdatesLayerWMS: [],
  loading: false,
  radarAvailable: true,
  heatIndexThresholds: [36, 39, 42],
  windChillThresholds: [-1, -4, -8],
  thresholdsLoaded: false,
};

export const persistedKeys: (keyof WatershedState)[] = [
  "islands",
  "watersheds",
  "islandId",
  "watershedId",
  "catchmentId",
  "allCatchments",
  "catchmentsData",
  "catchmentStations",
  "stationCode",
  "stationsData",
  "stationsSimulationData",
  "catchmentWaterLevelStationCode",
  "catchmentDischargeStationCode",
  "catchmentPrecipitationStationCode",
  "catchmentBlackspots",
  "mapLayerConfig",
  "mapLayerWMS",
  "equipamentsLayer",
  "plantesBaixesLayer",
  "soterranisLayer",
  "floodsLayer",
  "dataMode",
  "lastUpdatesLayerWMS",
];
